<section class="role-chooser" role="dialog" aria-modal="true" aria-labelledby="roleChooserTitle">
  <header class="role-chooser-head">
    <p class="app-title">Jansunwai</p>
    <img class="logo" src="/deoria-government-logo.jpg" alt="" />
    <h1 id="roleChooserTitle">{{ welcomeLine() }}</h1>
    <p class="sub">{{ t().chooseSubtext }}</p>
  </header>

  <div class="lang-row" role="group" [attr.aria-label]="t().langAria">
    <button
      type="button"
      class="lang-chip"
      [class.active]="lang() === 'en'"
      (click)="setLang('en')"
    >
      {{ t().langEn }}
    </button>
    <button
      type="button"
      class="lang-chip"
      [class.active]="lang() === 'hi'"
      (click)="setLang('hi')"
    >
      {{ t().langHi }}
    </button>
  </div>

  <ul class="role-list" role="listbox" [attr.aria-busy]="busy()">
    @for (role of roles(); track role) {
      <li role="presentation">
        <button
          type="button"
          class="role-card"
          role="option"
          [disabled]="busy()"
          [attr.aria-label]="label(role) + '. ' + description(role)"
          (click)="onPick(role)"
        >
          <span class="role-icon" aria-hidden="true">
            @switch (role) {
              @case ('records_officer') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <path d="M14 2v6h6M8 13h8M8 17h6" />
                </svg>
              }
              @case ('administrator') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 3 5 6v5c0 5 3.5 8.5 7 10 3.5-1.5 7-5 7-10V6l-7-3z" />
                </svg>
              }
              @case ('admin') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 20a8 8 0 0 1 16 0" />
                  <path d="M12 12v3M9 18h6" />
                </svg>
              }
              @default {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="7" height="7" rx="1" />
                  <rect x="14" y="3" width="7" height="7" rx="1" />
                  <rect x="3" y="14" width="7" height="7" rx="1" />
                  <rect x="14" y="14" width="7" height="7" rx="1" />
                </svg>
              }
            }
          </span>
          <span class="role-body">
            <span class="role-name">{{ label(role) }}</span>
            <span class="role-desc">{{ description(role) }}</span>
          </span>
          <span class="role-chevron" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="m9 6 6 6-6 6" />
            </svg>
          </span>
        </button>
      </li>
    }
  </ul>

  @if (busy()) {
    <p class="busy-hint" role="status">{{ t().switching }}</p>
  }

  <button type="button" class="sign-out-link" [disabled]="busy()" (click)="onSignOut()">
    {{ t().signOut }}
  </button>
</section>
